<!-- Content Wrapper. Contains page content -->
<!-- Content Header (Page header) -->

<!-- Main content -->
<section class="content-header">
    <h1>
        <span i18n="Homepage title@@Homepage">Homepage</span>
        <small>CLHUB</small>
    </h1>
</section>
<section class="content">
    <div class="box">
        <div class="box-header with-border">
            <h3 class="box-title" i18n="HomePage box title@@HomePageBoxTitle">Welcome to CLHUB</h3>
        </div>
        <div class="box-body">
            <span i18n="@@WelcomeMessage">This application includes many functionalities. To start, simply choose what you want to see in the menu on the left.</span><br />
            <br />
            <span i18n="@@ContactThe">If necessary, do not hesitate to contact the </span>&nbsp;<a href="mailto:it.support@cotral.com" i18n="@@ITDepartment">IT department</a>.
        </div>
    </div>
    <div class="col-md-6" style="padding-left: 0">
        <div class="box">
            <div class="box-header with-border">
                <h3 class="box-title" i18n="HomePage box reports@@HomePageBoxReport">My favorites reports</h3>
                <div class="box-tools pull-right">
                    <em class="fa fa-area-chart" style="padding: 5px;"></em>
                </div>
            </div>

            <div class="box-body">
                <table class="table table-hover" aria-describedby="favorites reports">
                  <caption class="hidden"></caption>
                  <thead class="hidden">
                    <tr>
                      <th scope="hidden"></th>
                    </tr>
                  </thead>
                    <tbody *ngIf="Reports.length > 0">
                        <tr *ngFor="let report of Reports">
                            <td *ngIf="report.customName" style="cursor: pointer;" class="col-sm-11" (click)="goToReport(report)">
                                <em class="fa fa-play" style="font-size: 12px"></em> {{report.customName}}
                            </td>
                            <td class="col-xs-1" style="text-align: center;">
                                <em class="fa fa-remove" style="cursor: pointer;" (click)="removeFromFavorite(report)"></em>
                            </td>
                            <tr>
                    </tbody>

                    <tbody *ngIf="Reports.length <= 0">
                        <tr>
                            <td i18n="No reports in your favorites@@NoPowerBIReportsFavorites">There is no report in your favorites for the moment…</td>
                        </tr>
                    </tbody>

                </table>
            </div>
        </div>
    </div>
    <div class="col-md-6" style="padding-right: 0">
        <div class="box">
            <div class="box-header with-border">
                <h3 class="box-title" i18n="HomePage box dashboard@@HomePageBoxDashboard">My favorites dashboards</h3>
                <div class="box-tools pull-right">
                    <em class="fa fa-dashboard" style="padding: 5px"></em>
                </div>
            </div>
            <div class="box-body">
                <table class="table table-hover" aria-describedby="Favorites dashboard">
                  <caption class="hidden"></caption>
                  <thead class="hidden">
                    <tr>
                      <th scope="hidden"></th>
                    </tr>
                  </thead>
                    <tbody *ngIf="Dashboards.length > 0">
                        <tr *ngFor="let dashboard of Dashboards">
                            <td *ngIf="dashboard.customName" style="cursor: pointer;" class="col-sm-11" (click)="goToDashboard(dashboard)">
                                <em class="fa fa-play" style="font-size: 12px"></em> {{dashboard.customName}}
                            </td>
                            <td class="col-xs-1" style="text-align: center;">
                                <em class="fa fa-remove" style="cursor: pointer;" (click)="removeFromFavorite(dashboard)"></em>
                            </td>
                            <tr>
                    </tbody>

                    <tbody *ngIf="Dashboards.length <= 0">
                        <tr>
                            <td i18n="No dashboards in your favorites@@NoPowerBIDashboardsFavorites">There is no dashboard in your favorites for the moment…</td>
                        </tr>
                    </tbody>

                </table>
            </div>
        </div>
    </div>
</section>
<!-- /.content -->
<div class="control-sidebar-bg"></div>
<!-- ./wrapper -->
